<template>
    <div style="position:relative">
        <v-btn color="primary"
               class="stocktake-btn"
               @click="showStocktake = true"
               prepend-icon="mdi-counter">
            STOCKTAKE COLOUR
        </v-btn>
        <v-data-table-server v-model:items-per-page="itemsPerPage"
                             v-if="typeof(totalItems) != undefined"
                             :headers="tableHeaders"
                             :items-length="totalItems"
                             :items="tableItems"
                             :loading="tableLoading"
                             density="compact"
                             @update:itemsPerPage="itemsPerPageChange"
                             @update:page="pageChange"
                             fixed-header>
            <template v-slot:[`item.job`]="{ item }">
                <job-link :job="item.job"></job-link>
            </template>
            <template v-slot:[`item.transactionDate`]="{ item }">
                {{ $dayjs(item.transactionDate).format('DD-MM-YYYY') }}
            </template>
            <template v-slot:[`item.quantity`]="{ item }">
                {{ numberWithCommas(item.quantity, 2) }}
            </template>
            <template v-slot:[`item.type`]="{ item }">
                <type-chip :type="item.type" entity="Stock" :object="item"></type-chip>
            </template>
        </v-data-table-server>
        <v-dialog v-model="showStocktake"
                  scrollable
                  persistent
                  :fullscreen="$windowWidth < 960"
                  min-width="80%"
                  width="auto">
            <v-card>
                 <v-toolbar theme="dark">
                     <v-toolbar-title>Update {{ object.name }} Stock Level</v-toolbar-title>
                     <v-btn icon="mdi-close"
                            @click="showStocktake = false"></v-btn>
                 </v-toolbar>
                 <v-card-text>
                     <small>20Kg box packaging weight is approx 1.12kg</small>
                     <v-form v-model="valid" @submit.prevent="saveTransaction" :disabled="loading">
                         <v-text-field label="As Of"
                                       type="date"
                                       :rules="[$rules.required]"
                                       v-model="transactionDate"></v-text-field>
                         <v-text-field label="Quantity"
                                       v-model="quantity"
                                       hint="Enter the KGs"
                                       :rules="[$rules.required]"
                                       suffix="kgs"></v-text-field>
                         <v-text-field v-model="reason"
                                       label="Reason"
                                       :rules="[$rules.required]"></v-text-field>
                         <v-alert density="compact"
                                  v-if="errors"
                                  type="warning"
                                  class="my-2"
                                  :title="errors.title">
                             <ul>
                                 <li v-for="error in errors.errors" :key="error" v-html="error[0]"></li>
                             </ul>
                         </v-alert>
                         <div class="mt-2">
                             <v-btn :loading="saving"
                                    :disabled="!valid"
                                    flat
                                    type="submit"
                                    color="primary"
                                    prepend-icon="mdi-floppy">SAVE</v-btn>
                             <v-btn flat class="ml-2" @click="showStocktake = false">CANCEL</v-btn>
                         </div>
                     </v-form>
                 </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .stocktake-btn {
        position:absolute;
        right:0px;
        top:-48px;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { mapActions, mapState } from "vuex";
    function initialState() {
        return {
            saving: false,
            showStocktake: false,
            loading: false,
            itemsPerPage: 10,
            totalItems: 0,
            tableItems: [],
            valid: true,
            tableLoading: false,
            page: 1,
            sortBy: null,
            transactionDate: null,
            reason: 'Update Stock Level',
            errors: null,
            quantity: null,

        };
    }
    export default {
        name: "StockTablePanel",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.transactionDate = this.$dayjs().format('YYYY-MM-DD');
            this.loadDatatable();
        },
        props: {
            object: Object,
            entity: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadDatatable() {
                this.tableLoading = true;
                let route = this.$constants.entities.Stock.ROUTE + "getcolourtransactions?page=" + this.page + "&itemsPerPage=" + this.itemsPerPage + "&colourId=" + this.object.id;
                this.$api.get(route)
                    .then(res => {
                        this.tableLoading = false;
                        this.tableItems = res.data.items;
                        this.totalItems = res.data.totalItems;
                    })
                    .catch(error => {
                        this.tableLoading = false;
                        this.showErrorSnack('There was an error loading the table data.');
                    });
            },
            itemsPerPageChange(itemsPerPage) {
                this.itemsPerPage = itemsPerPage;
                this.loadDatatable();
            },
            pageChange(page) {
                this.page = page;
                this.loadDatatable();
            },
            numberWithCommas,
            saveTransaction() {
                this.saving = true;
                let formData = new FormData();
                formData.append('id', this.object.id);
                formData.append('quantity', this.quantity);
                formData.append('date', this.transactionDate);
                formData.append('reason', this.reason);
                this.$api.post('/stock/stocktakecolour', formData)
                    .then(res => {
                        this.saving = false;
                        this.showStocktake = false;
                        this.loadDatatable();
                    }).catch(error => {
                        this.saving = false;
                        if (error.response.data && Array.isArray(error.response.data)) {
                            this.errors = error.response.data;
                        } else if (error.response.data.title) {
                            this.errors = { title: "Whoops", errors: [[error.response.data.title]] };
                        } else {
                            this.errors = { title: "Whoops", errors: [["There was an issue saving the colour."]] };
                        }
                    });
            }
        },
        computed: {
            ...mapState({
            }),
            tableHeaders() {
                return [
                    { title: 'Date', key: 'transactionDate', width: "10%" },
                    { title: 'Type', key: 'type', width: "10%" },
                    { title: 'Reason', key: 'reason', width: "50%" },
                    { title: 'Job', key: 'job', width: "20%" },
                    { title: 'Quantity', key: 'quantity', width: "10%" },
                ];
            }
        }
    };
</script>